import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../types';

const selectProfilePreferences = (state: AppState) => state.preferencesReducer;

export const selectAppTheme = createSelector(selectProfilePreferences, state => state?.theme);

export const selectIsMetric = createSelector(selectProfilePreferences, state => state?.isMetric);
